import type { RouteLocationNormalized } from 'vue-router'
import { setDocumentPageTitleFromRoute } from '@/lib/utils/documentTitle'

const MFE_HOST_ROUTE_NAMES = new Set([
  'AccountsMFE',
  'CommerceMFE',
  'ServiceMFE',
])

/**
 * Updates `document.title` for shell-owned routes only.
 * MFE host catch-alls defer to the active remote application's router.
 */
export const updateDocumentTitle = (to: RouteLocationNormalized): void => {
  if (to.name && MFE_HOST_ROUTE_NAMES.has(String(to.name))) {
    return
  }

  setDocumentPageTitleFromRoute(to)
}
